import {apiPathFn} from "@ntprsrf-frontend/common/src/utils/api";
import {Axios} from "axios-observable";
import {map} from "rxjs";
import {UserInteractionRequest} from "../../requests/internet/userInteraction.request";
import {SuccessSingleResponse} from "../../responses/base.response";


const apiPath = apiPathFn(import.meta.env.VITE_EZ_AUDIT_SERVICE);


export function recordUserInteraction(
  payload: UserInteractionRequest,
) {
  return Axios.post<SuccessSingleResponse<null>>(
    apiPath(["form", "interaction", "record"]),
    payload
  ).pipe(map((res) => res.data));
}